<ng-container *ngIf="getFilterToolbar()">
  <app-mu-sidebar
    customClass="mu-filter-toolbar-modal-anchor mu-filters-toolbar-content"
    [contentClass]="customClass"
    [flagList]="getFilterToolbar().flagList"
    [showFlag]="getFilterToolbar().showFlag"
  >
    <form class="p-grid">
      <app-mu-form-section [title]="getFilterToolbar().sideBarTitle" [gridSizeForm]="12" class="mu-full-width" [withAbsoluteButtons]="true">
        <div class="mu-description-filter" *ngIf="getFilterToolbar().descriptionFilter">
          <div>
            <span class="mu-icon-description-filter-toolbar">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <div>
            <span class="mu-description-filter-toolbar">
              {{ getFilterToolbar().descriptionFilter }}
            </span>
          </div>
        </div>
        <app-mu-form-fieldset [label]="filterField.filter" customGridCol="12" *ngFor="let filterField of filterFieldList">
          <ng-container *ngTemplateOutlet="filterField.filterTemplate; context: { $implicit: filterField }"></ng-container>
        </app-mu-form-fieldset>
        <app-mu-form-buttons [customGridCol]="12" [alwaysFullWidth]="true">
          <p-button
            muButtonLeft
            type="button"
            [label]="'form.button.deleteFilters' | translate"
            [class]="!disableDeleteFilter ? 'mu-button mu-button-outline mu-button-full-width' : 'mu-button mu-button-full-width'"
            (click)="closeSidebar(true)"
            [disabled]="disableDeleteFilter"
          ></p-button>
          <p-button
            muButtonRight
            [label]="'form.button.viewDeliveryFilter' | translate"
            class="mu-button mu-button-full-width"
            type="button"
            (click)="save()"
          >
            <app-loading [showLoading]="getFilterToolbar().flagList.get(getFilterToolbar().buttonLoaderFlag)" type="icon"></app-loading>
          </p-button>
        </app-mu-form-buttons>
      </app-mu-form-section>
    </form>
  </app-mu-sidebar>
</ng-container>
